import React from 'react';

import TagDiscounts from '../TagDiscounts/TagDiscounts';
import { ga4SelectPromotion } from '../../../shared/lib/ga4EnhancedEcommerce';
import { fkmxSelectPromotion } from '../../../shared/lib/farmakomMetrics';
import ImageThumbnail from '../../../shared/ImageThumbnail/ImageThumbnail';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const ModuleTagsDiscounts = ({
  tagsDiscounts,
  home,
  primaryColor,
  hasGoogleAnalytics4Advanced,
  hasFarmakomMetrics,
  discountTagsVersion,
  isMobile,
}) => {
  const onClick = tag => {
    if (hasGoogleAnalytics4Advanced) {
      // GA4 SELECT PROMOTION
      ga4SelectPromotion(tag);
    }
    if (hasFarmakomMetrics) {
      // FKMX SELECT PROMOTION
      fkmxSelectPromotion(tag);
    }
  };

  const renderModuleTagsDiscounts = () => {
    if (isMobile) {
      return renderModuleTagsDiscountsMobile();
    } else {
      return renderModuleTagsDiscountsDesktop();
    }
  };

  const renderModuleTagsDiscountsDesktop = () => {
    return (
      <div className="hidden-mobile">
        <TagDiscounts
          tags={tagsDiscounts}
          discountsTitle={home.discountsTitle}
          primaryColor={primaryColor}
          hasGoogleAnalytics4Advanced={hasGoogleAnalytics4Advanced}
          hasFarmakomMetrics={hasFarmakomMetrics}
          discountTagsVersion={discountTagsVersion}
        />
      </div>
    );
  };

  const renderModuleTagsDiscountsMobile = () => {
    return (
      <div className="hidden-desktop mobile-tags-container">
        {!!tagsDiscounts &&
          tagsDiscounts.map((tag, i) => {
            return (
              <div key={tag.id} className="mobile-image-container">
                <div className="image-thumbnail">
                  <a href={`/tag/${tag.seoName}`} onClick={() => onClick(tag)}>
                    <ImageDispatcher
                      className={`image-container ${i >= 2 ? 'lazyload' : ''}`}
                      alt={`Immagine offerte "${tag.name}"`}
                      src={tag.imageUrl}
                    />
                  </a>
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  return <>{renderModuleTagsDiscounts()}</>;
};

export default ModuleTagsDiscounts;
